export default {
  setLoading(state, payload) {
    state.loading = payload
  },
  setPatients(state, payload) {
    state.patients = payload
  },
  setDialogPatients(state, payload) {
    state.dialogPatients = payload
  },
  updateCurrentPatient(state, patient) {
    if (patient) {
      const featureFlagState = Object.keys(
        this.state.dictionariesStates.dictionaryFeatureFlagState,
      )
      if (patient.journalAvailable)
        patient.journalAvailable =
          featureFlagState.find(
            flagState =>
              flagState.toLowerCase() ===
              patient.journalAvailable.toLowerCase(),
          ) || patient.journalAvailable
      if (patient.smartSurveyAvailable)
        patient.smartSurveyAvailable =
          featureFlagState.find(
            flagState =>
              flagState.toLowerCase() ===
              patient.smartSurveyAvailable.toLowerCase(),
          ) || patient.smartSurveyAvailable
      if (patient.swapAvailable)
        patient.swapAvailable =
          featureFlagState.find(
            flagState =>
              flagState.toLowerCase() === patient.swapAvailable.toLowerCase(),
          ) || patient.swapAvailable
      if (patient.surveyAvailable)
        patient.surveyAvailable =
          featureFlagState.find(
            flagState =>
              flagState.toLowerCase() === patient.surveyAvailable.toLowerCase(),
          ) || patient.surveyAvailable
    }

    state.currentPatient = patient
  },
  setPagination(state, payload) {
    state.pagination = { ...payload }
  },
  setDialogPagination(state, payload) {
    state.dialogPagination = { ...payload }
  },
  setCalendar(state, payload) {
    state.journalDates = payload
  },
  setJournal(state, payload) {
    state.currentJournal = payload
  },
  setTimedReleaseMessages(state, payload) {
    state.timedReleaseMessages = payload
  },
  setTimedReleaseMessagesDefinitions(state, payload) {
    state.timedReleaseMessagesDefinitions = payload
  },
  setTimedReleaseMessagesDefinitionResource(state, payload) {
    state.timedReleaseMessagesDefinitionResource = payload
  },
  setPatientsFilters(state, payload) {
    state.patientsFilters = payload
  },
  setDialogPatientsFilters(state, payload) {
    state.dialogPatientsFilters = payload
  },
  setExercisesFilters(state, payload) {
    state.exercisesFilters = payload
  },
  setExercises(state, payload) {
    state.exercises = payload
  },
  setExercise(state, payload) {
    state.exercise = payload
  },
  setExercisesReport(state, payload) {
    state.exercisesReport = payload
  },
  setExercisesReportTotals(state, payload) {
    state.exercisesReportTotals = payload
  },
  setExercisesDayReport(state, payload) {
    if (
      state.exercisesDayReport.findIndex(item => item.date == payload.date) > -1
    )
      state.exercisesDayReport = state.exercisesDayReport.map(day => {
        if (day.date === payload.date) {
          return Object.assign({}, day, payload)
        }
        return day
      })
    else state.exercisesDayReport.push(payload)
  },
  clearExercisesDayReports(state, payload) {
    state.exercisesDayReport = []
  },
  setExercisesCalendar(state, payload) {
    state.exercisesCalendar = payload
  },
  setSwaps(state, payload) {
    state.swaps = payload
  },
  setSwap(state, payload) {
    state.swap = payload
  },
  setSwapsLoading(state, payload) {
    state.swapsLoading = payload
  },
  setSwapLoading(state, payload) {
    state.swapLoading = payload
  },
  toggleColumnLayout(state) {
    state.columnLayoutActive = !state.columnLayoutActive
  },
  setScreeners(state, payload) {
    state.screeners = payload
  },
  setScreener(state, payload) {
    state.screener = payload
  },
  setScreenerProgress(state, payload) {
    state.screenerProgress = payload
  },
  setParticipantsDashboard(state, payload) {
    state.participantsDashboard = payload
  },
  setCurrentAdvisorDashboardName(state, payload) {
    state.currentAdvisorDashboardName = payload
  },
  setCourses(state, payload) {
    state.courses = payload
  },
  setCurrentCourse(state, payload) {
    state.currentCourse = payload
  },
  setCurrentCourseSteps(state, payload) {
    state.currentCourseSteps = payload
  },
  setTimedReleaseMessagesDates(state, payload) {
    state.timedReleaseMessagesDates = payload
  },
}
